<div class="col-12 n-padding">
  <p>{{ zipCodeConfigurableData?.chooseCreditPlan }}</p>
</div>
<div
  class="col-12 n-padding"
  *ngIf="suggestedAddresses?.length && zipCodeValidationForm?.controls?.zip?.valid"
>
  <p>
    {{ zipCodeConfigurableData?.relevantOffers
    }}<span class="bold">
      {{ suggestedAddresses[0]?.cityName }},{{ suggestedAddresses[0]?.stateCode }}</span
    >
  </p>
</div>
<div
  class="col-8 col-md-4 m-t-md n-padding"
  *ngIf="zipCodeValidationForm"
  [formGroup]="zipCodeValidationForm"
>
  <div class="m-b-sm" *ngIf="apiError">
    <tmo-error-message-detail
      [errorText]="zipCodeConfigurableData?.noAddressFound"
      [formName]="'zipCodeValidationForm'"
    ></tmo-error-message-detail>
  </div>
  <tmo-input
    autoFocus="true"
    [type]="'number'"
    id="zip"
    [pattern]="zipCodeRegexPattern"
    [required]="true"
    aria-label="Text"
    formControlName="zip"
    (input)="updateZipCodeInformation($event?.target?.value)"
    [isInputDirty]="
      !zipCodeValidationForm?.controls?.zip?.valid && zipCodeValidationForm?.controls?.zip?.touched
    "
    [fieldType]="fieldValidationConstants?.ZIP_CODE"
    [id]="'tmo-input-default-119'"
  ></tmo-input>
</div>
<tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
